import React from 'react';
import {
    Routes,
    Route
} from 'react-router-dom';
import MenuAspirante from '../components/MenuAspirante';

// const Admin         = lazy( () => import('../pages/Admin') )
// const Examen        = lazy( () => import('../pages/Examen') )
// const Login         = lazy( () => import("../pages/Login") )
// const LoginAdmin    = lazy( () => import('../pages/LoginAdmin') )
// const NotFound      = lazy( () => import('../pages/NotFound') )
// const RutaPrivada   = lazy( () => import('./RutaPrivada') )

import Admin from '../pages/Admin';
import { Aspirantes } from '../pages/adminexamen/Aspirantes';
import Bachilleratos from '../pages/adminexamen/Bachilleratos';
import { EditarAspirantes } from '../pages/adminexamen/EditarAspirantes';
import { EditarBachillerato } from '../pages/adminexamen/EditarBachillerato';
import EditarPregunta from '../pages/adminexamen/EditarPregunta';
import Materias from '../pages/adminexamen/Materias';
import PreguntasMaterias from '../pages/adminexamen/PreguntasMaterias';
import SubirDatos from '../pages/adminexamen/SubirDatos';
import Examen from '../pages/examen/Examen';
import { ResponderExamen } from '../pages/examen/ResponderExamen';
import Login from "../pages/Login";
import LoginAdmin from '../pages/LoginAdmin';
import NotFound from '../pages/NotFound';
import { Reportes } from "../pages/adminexamen/Reportes";
import ConfiguracionesAplicacion from "../pages/adminexamen/ConfiguracionesAplicacion";
import RutaPrivada from './RutaPrivada';
import ReporteCoordinacion from '../pages/adminexamen/ReporteCoordinacion';
import ReporteCarrera from '../pages/adminexamen/ReporteCarrera';
import BuscarAspirante from '../pages/adminexamen/BuscarAspirante';
import { BotonCerrarSesion } from '../components/BotonCerrarSesion';
import RegistroAspiranteIndividual from '../pages/adminexamen/RegistroAspiranteIndividual';
import Correos from '../pages/adminexamen/Correos';
import InscribirAspirantes from '../pages/adminexamen/InscribirAspirantes';
import AspirantesInscritos from '../pages/adminexamen/AspirantesInscritos';
import { CorreosEnviados } from '../pages/adminexamen/CorreosEnviados';

const AppRouter = () => {
    return(
        <>
            <Routes>

                <Route path="/" element={ <Login/> }/>
                {/* <Route path="/login" element={ <p>hola owo</p> }/>*/}
                <Route path="/examen" element={<MenuAspirante componente={<Examen />} btnCerrarSesion={<BotonCerrarSesion />} />} />

                <Route path="/examen/:id" element={ <MenuAspirante componente={ <ResponderExamen/> } /> }/>

                <Route path="/login" element={ <LoginAdmin/> }/>
                <Route path="/admin" element={
                    <RutaPrivada children={ <Admin/> } title='Panel principal'/>
                }/>


                {/* admin examen */}
                <Route path='/subir-datos' element={
                    <RutaPrivada children={ <SubirDatos/> } title='Cargar aspirantes'/>
                }/>

                <Route path='/aspirantes' element={
                    <RutaPrivada children={ <Aspirantes/> } title='Lista de aspirantes'/>
                }/>

                <Route path='/registrar' element={
                    <RutaPrivada children={ <RegistroAspiranteIndividual/> } title='Registrar aspirante'/>
                }/>

                <Route path='/aspirantes/editar/:id' element={
                    <RutaPrivada children={ <EditarAspirantes/> } title='Editar información de aspirante'/>
                }/>

                <Route path='/bachilleratos' element={
                    <RutaPrivada children={ <Bachilleratos/> } title='Lista de bachilleratos'/>
                }/>

                <Route path='/bachilleratos/editar/:id' element={
                    <RutaPrivada children={ <EditarBachillerato/> } title='Editar información de bachillerato'/>
                }/>


                <Route path='/materias' element={
                    <RutaPrivada children={ <Materias/> } title='Lista de materias'/>
                }/>

                <Route path='/materias/:id' element={
                    <RutaPrivada children={ <PreguntasMaterias/> } title='Agregar preguntas'/>
                }/>

                <Route path='/materias/:id/editar_pregunta/:id_pregunta' element={
                    <RutaPrivada children={ <EditarPregunta/> } title='Editar pregunta'/>
                }/>

                <Route path='/reportes' element={
                    <RutaPrivada children={ <Reportes/> } title='Reportes'/>
                }/>

                <Route path='/configuracion_aplicacion' element={
                    <RutaPrivada children={ <ConfiguracionesAplicacion/> } title='Configuraciones de aplicación'/>
                }/>

                <Route path='/correos' element={
                    <RutaPrivada children={ <Correos/> } title='Envío de correos'/>
                }/>

                <Route path='/correos_enviados' element={
                    <RutaPrivada children={ <CorreosEnviados/> } title='Correos enviados'/>
                }/>

                <Route path='/inscribir_aspirante' element={
                    <RutaPrivada children={ <InscribirAspirantes/> } title='Inscribir aspirantes'/>
                }/>

                <Route path='/aspirantes_inscritos' element={
                    <RutaPrivada children={ <AspirantesInscritos/> } title='Aspirantes Inscritos'/>
                }/>


                {/* coordinadores */}
                <Route path='/coordinadores' element={
                    <RutaPrivada children={ <ReporteCoordinacion/> } tipo='COORDINADOR' title='Reportes de coordinación' />
                }/>

                <Route path='/reporte-carrera/:id' element={
                    <RutaPrivada children={ <ReporteCarrera/> } tipo='COORDINADOR' title='Reportes de coordinación' />
                }/>


                {/* aplicadores */}
                <Route path='/buscar-aspirante' element={
                    <BuscarAspirante/>
                }/>


                <Route path="/404" element={ <NotFound/> }/>
                <Route path="*" element={ <NotFound/> }/>


            </Routes>
        </>
    );
};

export default AppRouter;
